// import { filterImage, redrawCanvas, red, green, blue, sharpen, bigGaussian } from "lena.js";
import { Filters } from "./filters";

const canvas = window.document.createElement('canvas');

function getImageChannel(image, channel, filters, loadedMethod) {
    const mainImage = image.getImage();

    let sharpenValue = filters ? filters.sharpen : 0;
    let blurValue = filters ? filters.blur : 0;

    let context = canvas.getContext('2d');
    canvas.height = mainImage.naturalHeight;
    canvas.width = mainImage.naturalWidth;
    context.drawImage(mainImage, 0, 0);

    if (sharpenValue > 0) {
        let imageData = context.getImageData(0, 0, mainImage.naturalWidth, mainImage.naturalHeight);
        const maxSharpen = 5;
        const v1 = maxSharpen * sharpenValue / 100;
        const v2 = v1 * 4 + 1;
        const sharpenMatrix = Filters.getFloat32Array(
            [0, -v1, 0,
                -v1, v2, -v1,
                0, -v1, 0]
        );
        imageData = Filters.convolve(imageData, sharpenMatrix, false);
        context.putImageData(imageData, 0, 0);
    }

    if (blurValue && blurValue > 0) {
        let imageData = context.getImageData(0, 0, mainImage.naturalWidth, mainImage.naturalHeight);
        imageData = Filters.gaussianBlur(imageData, blurValue / 2);
        context.putImageData(imageData, 0, 0);
    }

    if (channel === "rChannel" || channel === "gChannel" || channel === "bChannel") {
        let imageData = context.getImageData(0, 0, mainImage.naturalWidth, mainImage.naturalHeight);
        let data = imageData.data;
        for (var i = 0; i < data.length; i += 4) {
            if (channel === "rChannel") {
                data[i] = data[i];
                data[i + 1] = data[i];
                data[i + 2] = data[i];
                // data[i] = data[i];
                // data[i + 1] = 0;
                // data[i + 2] = 0;
            } else if (channel === "gChannel") {
                data[i] = data[i + 1];
                data[i + 1] = data[i + 1];
                data[i + 2] = data[i + 1];
            } else if (channel === "bChannel") {
                data[i] = data[i + 2];
                data[i + 1] = data[i + 2];
                data[i + 2] = data[i + 2];
            }
        }
        context.putImageData(imageData, 0, 0);
    }

    canvas.toBlob(function (blob) {
        const newImg = new window.Image();
        const url = URL.createObjectURL(blob);

        newImg.src = url;
        newImg.onload = function () {
            // no longer need to read the blob so it's revoked
            let imageR = {
                imageId: image.imageId,
                minPixelValue: image.minPixelValue,
                maxPixelValue: image.maxPixelValue,
                slope: image.slope,
                intercept: image.intercept,
                windowCenter: image.windowCenter,
                windowWidth: image.windowWidth,
                render: image.render,
                getPixelData: image.getPixelData,
                getCanvas: image.getCanvas,
                getImage: () => newImg,
                rows: image.rows,
                columns: image.columns,
                height: image.height,
                width: image.width,
                color: image.color,
                rgba: image.rgba,
                columnPixelSpacing: image.columnPixelSpacing,
                rowPixelSpacing: image.rowPixelSpacing,
                invert: image.invert,
                sizeInBytes: image.sizeInBytes
            };

            loadedMethod(imageR);

            URL.revokeObjectURL(url);
        };
    });

}

export { getImageChannel };
